import cn from "classnames";
import { parseMarkedText } from "./MacMenuExamplesMarkedText.helpers";

interface MacMenuExamplesMarkedTextProps {
    text: string;
}

function MacMenuExamplesMarkedText({ text }: MacMenuExamplesMarkedTextProps) {
    let offset = 0;

    // One wrapping element keeps the runs in a single text flow; as bare children of a flex cell
    // each run would become its own flex item and lose the spaces at its edges.
    return (
        <span className="MacMenuExamples__text">
            {parseMarkedText(text).map((segment) => {
                // Keyed by where the run starts, so an earlier match moving doesn't renumber the rest.
                const key = offset;
                offset += segment.text.length;

                if (!segment.isMatch && !segment.isSecondary) {
                    return <span key={key}>{segment.text}</span>;
                }

                // A run with both marks is a primary match the search also hit: the primary (bold) wins.
                return (
                    <mark
                        key={key}
                        className={cn('MacMenuExamples__match', { 'is-secondary': !segment.isMatch })}
                    >
                        {segment.text}
                    </mark>
                );
            })}
        </span>
    );
}

export default MacMenuExamplesMarkedText;
